export const getFormattedResult = number => {
  if (parseInt(number, 10) === 0) {
    return '<1';
  }

  return number;
};
